import * as React from 'react';
import { OutreachPushFormContainer, VenueRecommendationsCell } from '@weddingspot/ws-core-components';
import { MassInquiryPageData } from '../../types';

const styles = require('./MassInquiryPage.scss');

interface Props {
    venueData: MassInquiryPageData;
    unselectedPos?: number;
    userToken: string;
    onFormSubmit: (positions: number[]) => void;
    onBrowseMore: () => void;
}

enum PageStep {
    FORM = 1,
    SUCCESS = 2,
}

interface State {
    step: PageStep;
}

class MassInquiryPage extends React.Component<Props, State> {
    readonly state: State = {
        step: PageStep.FORM,
    };

    constructor(props: Props) {
        super(props);

        this.onSubmitSuccess = this.onSubmitSuccess.bind(this);
        this.onBrowseMore = this.onBrowseMore.bind(this);
    }

    onSubmitSuccess(positions: number[]) {
        this.setState({ step: PageStep.SUCCESS });
        this.props.onFormSubmit(positions);
    }

    onBrowseMore() {
        this.props.onBrowseMore();
        window.location.href = '/wedding-venues/';
    }

    renderForm() {
        const { venueData } = this.props;

        return (
            <div className={styles.wrapper}>
                <OutreachPushFormContainer
                    handleExtraOutreachSuccess={this.onSubmitSuccess}
                    handleRejectExtraOutreach={() => {}}
                    venueIds={venueData.map((venue) => {
                        return venue.id;
                    })}
                    unselectedPos={!!this.props.unselectedPos ? [this.props.unselectedPos] : []}
                    userToken={this.props.userToken}
                    primaryCopy='Get pricing!'
                >
                    <div className={styles.venueCellsWrapper}>
                        {venueData.map((venue, idx) => {
                            return <VenueRecommendationsCell key={idx} position={idx} outreachPush={true} {...venue} />;
                        })}
                    </div>
                </OutreachPushFormContainer>
            </div>
        );
    }

    renderSuccess() {
        return (
            <div className={styles.successWrapper}>
                <div>Inquiries sent! You’ll be notified when they respond. Meanwhile, check out some more venues.</div>
                <div>
                    <button className='nx-button nx-button--primary' onClick={this.onBrowseMore}>
                        Browse more
                    </button>
                </div>
            </div>
        );
    }

    render() {
        switch (this.state.step) {
            case PageStep.FORM:
                return this.renderForm();
            case PageStep.SUCCESS:
                return this.renderSuccess();
            default:
                return this.renderSuccess();
        }
    }
}

export default MassInquiryPage;
